import { useQuery } from '@tanstack/react-query';

import type { PricingDetails } from '~/interfaces/subscriptions';

interface Props {
  enabled: boolean;
  subscriberId: string;
}
interface ReturnProps {
  isLoading: boolean;
  data?: PricingDetails | Record<string, never>;
}

const useStaticPricingDetails = ({ enabled, subscriberId }: Props): ReturnProps => {
  const { data, isLoading } = useQuery({
    queryKey: ['pricing-details', subscriberId],
    queryFn: async (): Promise<PricingDetails | Record<string, never>> => {
      const response = await fetch('/pricing_details');
      if (!response.ok) {
        throw new Error('Failed to load pricing details');
      }
      return response.json();
    },
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  return { isLoading, data };
};
export default useStaticPricingDetails;
